
import React from 'react';
import { Button, Spinner, Col, Row, Form, FormGroup, Label, Input, Alert,
    Nav, NavItem, NavLink, TabContent, TabPane, CustomInput,
    Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback, FormText, Container } from 'reactstrap';
import { Prompt, NavLink as RouterNavLink, Link } from 'react-router-dom';
import classnames from 'classnames';

export default function UserTopNav({activeTab, selectedUserId}:any) {
    return (
        <Nav tabs horizontal="true">
            <NavItem >
                <NavLink className={classnames({ active: activeTab === 'Profile' })} href={'/#/users/' + selectedUserId}>
                    <i className="fas fa-id-card mr-1"></i>Profile
                </NavLink>
            </NavItem>
            <NavItem>
                <NavLink className={classnames({ active: activeTab === 'Identity' })} href={'/#/users/' + selectedUserId + '/identity'}>
                    <i className="fas fa-user mr-1"></i>Identity
                </NavLink>
            </NavItem>
            <NavItem>
                <NavLink className={classnames({ active: activeTab === 'Courses' })} href={'/#/users/' + selectedUserId + '/courses'}>
                    <i className="fas fa-play mr-1"></i>User Courses
                </NavLink>
            </NavItem>
            <NavItem>
                <NavLink className={classnames({ active: activeTab === 'Password' })} href={'/#/users/' + selectedUserId + '/resetPassword'}>
                    <i className="fas fa-key mr-1"></i>Reset Password
                </NavLink>
            </NavItem>
        </Nav>
    )
}